// extracted by mini-css-extract-plugin
module.exports = {"sections":"homepage-sections_sections___N9_2","hero":"homepage-sections_hero__Zq_fa"};